//
//
//
//
//
//

export default {
  name: 'DpPageWrapper',
};
